var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from "styled-components";
import Icon from './IconBase';
function EmailIcon(_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    if (!(props.width || props.height)) {
        props = Object.assign(__assign({}, props), { width: 20 });
    }
    // #7E94A7; #00294D
    return (React.createElement(Icon, __assign({ "data-icon": 'pending', fill: 'none', viewBox: '0 0 20 16' }, props),
        React.createElement("g", { transform: 'translate(1.666667, 1.333333)', stroke: color || 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' },
            React.createElement("path", { d: 'M1.66666667,0 L15,0 C15.9166667,0 16.6666667,0.75 16.6666667,1.66666667 L16.6666667,11.6666667 C16.6666667,12.5833333 15.9166667,13.3333333 15,13.3333333 L1.66666667,13.3333333 C0.75,13.3333333 0,12.5833333 0,11.6666667 L0,1.66666667 C0,0.75 0.75,0 1.66666667,0 Z', id: 'Path' }),
            React.createElement("polyline", { id: 'Path', points: '16.6666667 1.66666667 8.33333333 7.5 0 1.66666667' }))));
}
export default styled(EmailIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
